import { CustomForm, CustomFormArray, CustomFormControl, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { ProvValidator } from "@tilby/tilby-ui-lib/utilities";
import { ItemThumbnailType } from "src/app/core/services/images-manager";
import { ItemsForm } from "src/app/features/items/models/items-form.model";
import { ItemsCombinations, ItemsCombinationValues, ItemsVariations, ItemsVariationValues } from "tilby-models";

export type ItemVariationsFormGroups = CustomFormGroup<ItemsFormWithCustomVariations>;
export type VariationsFormGroup = CustomFormArray<CustomFormGroup<ItemsVariationsWithCustomVariationsValue>>;
export type CombinationsFormGroup = CustomFormArray<CustomFormGroup<ItemsVariationsWithCustomCombinationsValue>>;

export type ItemsFormWithCustomVariations = Omit<ItemsFormExtended, 'variations' | 'combinations'> & {
    variations?: VariationsFormGroup;
    combinations?: CombinationsFormGroup;
};

export type ItemsFormExtended = ItemsForm & {combinationsActive?: CustomFormControl<boolean>};

export type ItemsVariationsWithCustomVariationsValue = Omit<ItemVariationsFormArray, 'variation_values'> & {
    variation_values?: CustomFormArray<CustomFormGroup<ItemsVariationValuesFormArray>>;
}

export type ItemVariationsFormArray = Partial<CustomForm<ItemVariationsFields>>;
export type ItemVariationsFields = ItemsVariations & ItemsVariationsFieldsFe;

export type ItemsVariationValuesFormArray = Partial<CustomForm<ItemVariationValuesFields>>;
export type ItemVariationValuesFields = ItemsVariationValues & ItemsVariationValuesFe;



export type ItemsVariationsWithCustomCombinationsValue = Omit<ItemCombinationsFormArray, 'combination_values'> & {
    combination_values?: CustomFormArray<CustomFormGroup<ItemsCombinationValuesFormArray>>;
}

export type ItemCombinationsFormArray = Partial<CustomForm<ItemCombinationsFields>>;
export type ItemCombinationsFields = ItemsCombinations & ItemsCombinationsFe;

export type ItemsCombinationValuesFormArray = Partial<CustomForm<ItemCombinationValuesFields>>;
export type ItemCombinationValuesFields = ItemsCombinationValues & ItemCombinationValueFe & ItemVariationsFields;

interface ItemsVariationsFieldsFe {
    index?: number;
    expanded?: boolean;
    variation_value_search?: string;
    tmp_id?: string;
}

export interface ItemsVariationValuesFe {
    _linkedItemName?: string;
    _image?: ItemThumbnailType;
    expanded?: boolean;
    tmp_id?: string;
}
export interface ItemsCombinationsFe {
    combination_name?: string;
    name_added_variant? : string;
    price6?: number;
    price7?: number;
    price8?: number;
    price9?: number;
    price10?: number;
    expanded?: boolean;
}

export interface ItemCombinationValueFe {
    variation_value_list?: ItemVariationValuesFields[];
    variation_id?: number;
    tmp_variation_id?: string;
    tmp_variation_value_id?: string;
}

export interface ItemVariationsValidators extends ProvValidator {
    nameMaxLength: number;
    nameVariantValueMaxLength: number;
    minValueMinQt: number;
    minValueMaxQt: number;
    minPriceCombination: number;
    skuMaxLength: number;
    nameAddedVariantMaxLength: number;
}

export const VARIATIONS_FE_KEYS = [
    'combinationsActive',
    'expanded',
    'tmp_id',
    'variation_value_search',
    '_linkedItemName',
    'combination_name',
    'name_added_variant',
    'variation_value_list',
    'tmp_variation_id',
    'tmp_variation_value_id'
]